import { render, staticRenderFns } from "./code-guide.vue?vue&type=template&id=22e13eaf&scoped=true&"
import script from "./code-guide.vue?vue&type=script&lang=ts&"
export * from "./code-guide.vue?vue&type=script&lang=ts&"
import style0 from "./code-guide.vue?vue&type=style&index=0&id=22e13eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e13eaf",
  null
  
)

export default component.exports